import styled from '@emotion/styled';
import { Text, tokens } from '@hotjar/hotsauce';

export const Wrapper = styled.div`
  ${tokens.flexCenter()};
  flex-direction: column;
  width: 100%;
  padding: ${tokens.spacer.x8};
`;

export const SubtitleContainer = styled(Text)`
  display: flex;
  flex-direction: column;
  margin: 0;
`;

export const BottomMarginSubtitle = styled(Text)`
  margin: 0 0 ${tokens.spacer.x1};
`;

export const NoMarginSubtitle = styled(Text)`
  margin: 0;
`;

export const NoButtonSubtitle = styled(Text)`
  margin: -${tokens.spacer.x3} 0 0;
`;
